export default class WizardController {

	private currentStepIndex: number;
	private isNextPrevented: boolean;

    stepValidation: (callbackArgs: {
        stepIndex: number
    }) => void;

	constructor () {
	}

    onBackClick = function ($event: MouseEvent, currentStepIndex: number) {
        if(this.currentStepIndex > 0) {
            this.currentStepIndex = this.currentStepIndex - 1;
        }

    };

    onNextClick = function ($event: MouseEvent, currentStepIndex: number) {

        this.onNext();

        if (!this.isNextPrevented) {
            this.currentStepIndex = this.currentStepIndex + 1;
        }
    };

    onFinishClick = function ($event: MouseEvent) {
        this.onFinish();
    };

    onCancelClick = function ($event: MouseEvent) {
        this.onCancel();
    };

}




/** WEBPACK FOOTER **
 ** ./app/common/components/wizard/wizard.controller.ts
 **/